import {
  getContentfulRevision,
  subscribeContentfulRevision,
} from '@/core/services/contentfulRefreshService';
import { useSyncExternalStore } from 'react';

/**
 * Number that changes after each app-wide Contentful refresh (app back in the
 * foreground). Add it to the deps of an effect that loads Contentful so an open
 * screen shows CMS changes without being reopened.
 */
export function useContentfulRevision(): number {
  return useSyncExternalStore(
    subscribeContentfulRevision,
    getContentfulRevision,
    getContentfulRevision,
  );
}
